import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { PlusOutlined } from '@ant-design/icons'
import { Button, Modal, Pagination, Table, Tabs } from 'hljd'
import columns from './columns'
import mStore from '../../store'
import mainStore from '@components/Main/store'
import { MATERIAL_PATH_A, MATERIAL_PATH_ADD_A } from '@constant'
import style from './style.module.less'
import { getMerchantInfo } from '@util'
import contractDetailColumns from './contractDetailColumns'
const { TabPane } = Tabs
const count = {
  '0': '一',
  '1': '二',
  '2': '三'
}
@observer
export default class extends Component {
  componentWillUnmount() {
    //因为是直接引入store，即经典的单例模式，导致数据无法重置，需要手动重置
    mStore.mealIDs = []
    mStore.materialList = []
    mainStore.getShopInfo()
  }
  jumpMaterialCenter = type => {
    if (type === 'add') {
      window.location.href = MATERIAL_PATH_ADD_A
    } else {
      window.location.href = MATERIAL_PATH_A
    }
    mStore.toggleSettingModal()
    mStore.materialModalVisible = false
  }

  contractContentGenerator = () => {
    const {
      details: { skip_contract_merchant = 0, contracts = [] }
    } = mStore
    if (skip_contract_merchant === 1) {
      return <div style={{ fontSize: 16 }}>合同线下进行签署</div>
    }
    return (
      <Table
        columns={contractDetailColumns}
        dataSource={toJS(contracts)}
        rowKey="contract_id"
        pagination={{ hideOnSinglePage: true }}
      />
    )
  }

  render() {
    const {
      details: { order_subs = [] }
    } = mStore
    return (
      <div className={style.detail}>
        <h4 className={style.title}>订单详情</h4>
        <Tabs defaultActiveKey="1">
          <TabPane tab="订单内容" key="1">
            <Table
              columns={columns(getMerchantInfo())}
              dataSource={toJS(order_subs)}
              pagination={false}
              rowKey="id"
            />
          </TabPane>
          <TabPane tab="合同详情" key="2">
            {this.contractContentGenerator()}
            {/*<Table
              columns={contractDetailColumns}
              dataSource={toJS(contracts)}
              rowKey="contract_id"
              pagination={{ hideOnSinglePage: true }}
            />*/}
          </TabPane>
        </Tabs>
        <Modal
          title="设置套餐"
          visible={mStore.packageSettingModalVisible}
          onCancel={mStore.toggleSettingModal.bind(this, undefined)}
          onOk={mStore.toggleSettingModal.bind(this, undefined, 'save')}
          bodyStyle={{
            padding: 0
          }}
          width={480}
        >
          <div className={style['setting-wrapper']}>
            <p className={style['setting-header']}>
              每个广告位支持最多设置3个<span style={{ color: '#FF801A' }}>
                创意中心
              </span>中的套餐，设置的套餐将在对应的位置轮播展示，请在广告开始前<span
                style={{ color: '#FF801A' }}
              >
                （{mStore.currentPacakgeDetail.scheduleBegin.split(' ')[0] ||
                  new Date().toLocaleDateString().replace(/\//g, '-')}）
              </span>设置
            </p>
            {toJS(mStore.currentPacakgeDetail.elements).map((item, index) => {
              return (
                <div
                  className={style['package-item']}
                  key={index}
                  onClick={mStore.toggleMaterialModal}
                >
                  <span className={style['label']}>套餐{count[index]}：</span>
                  <div
                    className={style['content']}
                    style={{
                      border: `${item.id ? 'none' : '1px dashed #ccc'}`
                    }}
                  >
                    {!item.id ? (
                      <>
                        <PlusOutlined className={style['icon']} />
                        <span className={style['add']}>添加套餐</span>
                      </>
                    ) : (
                      <>
                        <img
                          src={`${item.setMeal.coverPath}?imageView2/2/w/140`}
                          className={style['cover']}
                        />
                        <div className={style['detail']}>
                          <h4>{item.setMeal.title}</h4>
                          <span className={style['time']}>
                            发布日期：{item.setMeal.publishedTime.split(' ')[0]}
                          </span>
                        </div>
                        <i
                          className={style['close']}
                          onClick={mStore.deletePackage(index)}
                        />
                      </>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </Modal>

        <Modal
          visible={mStore.materialModalVisible}
          title="选择展示素材"
          width={800}
          onCancel={mStore.toggleMaterialModal}
          bodyStyle={{
            paddingBottom: '20px'
          }}
          footer={[
            <Button
              type="primary"
              key="primary"
              onClick={this.jumpMaterialCenter.bind(this, 'add')}
            >
              添加素材
            </Button>,
            <Button
              type="default"
              key="default"
              onClick={this.jumpMaterialCenter.bind(this, undefined)}
            >
              创意中心
            </Button>,
            <Button
              type="primary"
              key="save"
              onClick={mStore.setPackage.bind(this, undefined)}
            >
              保存
            </Button>
          ]}
        >
          <div className={style['material_wrapper']}>
            {toJS(mStore.materialList).length == 0 ? (
              <p className={style['no_material']}>
                还没有审核通过的素材，上传一个吧～
              </p>
            ) : (
              <div className={style['material_list_wrapper']}>
                {toJS(mStore.materialList).map((item, index) => {
                  const {
                    detail: { set_meals_data }
                  } = item
                  return (
                    <div
                      className={style['material-item']}
                      key={item.id}
                      onClick={mStore.togglePackageCheck(
                        item.detail.set_meals_data.id,
                        index
                      )}
                    >
                      <img
                        src={`${set_meals_data.cover_path}?imageView2/2/w/160`}
                      />
                      <div className={style['material-info']}>
                        <h4>{set_meals_data.title}</h4>
                        <div className={style['material-price']}>
                          <i className={style['big-price']}>
                            ￥{set_meals_data.actual_price}
                          </i>
                          <i className={style['small-price']}>
                            <s>￥{set_meals_data.show_price}</s>
                          </i>
                        </div>
                      </div>
                      <i
                        className={`${style['unActive']} ${
                          item.active ? style['active'] : ''
                        }`}
                      />
                    </div>
                  )
                })}
                <div className={style['pagination']}>
                  <Pagination
                    size="small"
                    total={Number(mStore.param.total)}
                    current={mStore.param.page}
                    onChange={mStore.handleMaterialPagination}
                  />
                </div>
              </div>
            )}
          </div>
          <p style={{ marginTop: 10 }}>
            如果需要选择更多套餐，请先去【创意中心】-【套餐类】中上传
          </p>
        </Modal>
      </div>
    )
  }
}
